<div class="m-header">
  <!-- Full brand — shown when the sidebar is open -->
  @if (!navCollapsed) {
    <a
      [routerLink]="home.path"
      [queryParams]="home.queryParams"
      class="b-brand"
    >
      @if (headerLogo) {
        <img [src]="headerLogo" width="160px" [alt]="tenantName" class="logo logo-tenant" />
      }
      @if (!headerLogo && tenantName) {
        <span class="tenant-logo-text">{{ tenantName }}</span>
      }
      @if (!headerLogo && !tenantName) {
        <img width="160px" src="assets/images/health-drive/HD1.svg" alt="" class="logo logo-default" />
      }
    </a>
  }

  <!-- Icon-only brand mark — shown when the sidebar is collapsed -->
  @if (navCollapsed) {
    <a
      [routerLink]="home.path"
      [queryParams]="home.queryParams"
      class="b-brand b-brand-icon"
      [title]="tenantName || 'Home'"
    >
      <img src="assets/images/health-drive/brand-icon.svg" alt="" class="logo-icon" />
    </a>
  }
</div>

<!-- [ Header ] end -->
